import { BaseVo } from "./baseVo";
import language from "@/language";
import pcmobile from "@/pcmobile";
import router from '@/router'
export class simpleVo extends BaseVo{

  num=null;

  get id(){
    return this.$data.id;
  }

  get cover(){
    return this.$data.cover;
  }

  get title(){
    return language.text(this.$data.title.cn,this.$data.title.en);
  }

  get startAt(){
    return this.$data.startAt ? new Date(this.$data.startAt) : null;
  }
  get endAt(){
    return this.$data.endAt ? new Date(this.$data.endAt) : null;
  }

  get summary(){
    return language.text(this.$data.summary.cn,this.$data.summary.en);
  }
  get planner(){
    return language.text(this.$data.planner.cn,this.$data.planner.en);
  }
  get address(){
    return language.text(this.$data.address.cn,this.$data.address.en);
  }



  goDetail(){
    router.push("/exhibition/detail?id="+this.id);
  }

}


export class infoVo extends simpleVo{

  get banner(){
    return pcmobile.get(this.$data.banner,this.$data.bannerM);
  }
  get buyQr(){
    return this.$data.buyQr;
  }
  get file(){
    return this.$data.file;
  }

  get actor(){
    if(!this.$data.actor){
      return null;
    }
    let actor = language.text(this.$data.actor.cn,this.$data.actor.en);
    let actors = actor.split("\n");
    let ret = [];
    for(let i in actors){
      if(actors[i]){
        ret.push(actors[i]);
      }
    }
    return ret;
  }
  get preface(){
    return language.text(this.$data.preface.cn,this.$data.preface.en);
  }
  get filename(){
    return language.text(this.$data.filename.cn,this.$data.filename.en);
  }
  get context(){
    return language.text(this.$data.context.cn,this.$data.context.en);
  }
}




export class imageVo extends BaseVo{

  get cover(){
    return this.$data.cover;
  }

  get alt(){
    return language.text(this.$data.alt ? this.$data.alt.cn : null, this.$data.alt ? this.$data.alt.en : null);
  }
}

export class derivativeVo extends BaseVo{

  get cover(){
    return this.$data.cover;
  }

  get name(){
    return language.text(this.$data.name.cn,this.$data.name.en);
  }

  get cate(){
    return language.text(this.$data.cate.cn,this.$data.cate.en);
  }
}



// WEBPACK FOOTER //
// ./src/vo/exhbitionVo.js